<template>
  <!-- LIST ITEM IN SIDEBAR -->
  <!-- <li
    v-if="getCurrentBookshelf"
    :key="bookshelf.id"
    :class="{ active: getCurrentBookshelf.id === bookshelf.id }"
  > -->
  <li
    :key="bookshelf.id"
    :class="{
      active: getCurrentBookshelf && getCurrentBookshelf.id == bookshelf.id
    }"
  >
    <button
      class="snb_list"
      @click="navigateBookshelf(bookshelf.id), $emit('closeMobileMenu')"
      @keypress.enter="
        navigateBookshelf(bookshelf.id), $emit('closeMobileMenu')
      "
    >
      <span>
        <b>▶</b> {{ bookshelf.name }} <span class="num_style">({{ num }})</span>
      </span>
    </button>
    <span></span>
    <div class="select_area">
      <div class="select_item" :class="{ active: showEditMenu }">
        <!-- DROPDOWN MENU BUTTON (Shown when ListItem is 'active')-->
        <button
          v-if="!bookshelf.isDefault && bookshelf.bookshelfTp === 'UBS'"
          v-on-clickaway="closeEditMenu"
          type="button"
          class="select_option btn_snb_modify"
          @click="toggleEditMenu"
        >
          {{ $t('library.listitem.edit') }}
        </button>
        <!-- <span></span> -->
        <!-- DROPDOWN MENU -->
        <ul class="select_list">
          <template>
            <li>
              <button
                type="button"
                class="list_option"
                @click.stop="toggleEditMenu"
                @click="$emit('openEditModal')"
              >
                <span>{{ $t('library.listitem.edit') }}</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                class="list_option"
                @click="$emit('openDeleteModal')"
              >
                <span>{{ $t('library.listitem.delete') }}</span>
              </button>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  BOOKSHELF_SET_CURRENT,
  BOOKSHELF_BOOK_GET_LIST,
  BOOKSHELF_BOOK_COUNT
} from '@/store/types'

export default {
  name: 'ListItem',
  props: {
    bookshelf: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showEditMenu: false,
      num: 0
    }
  },
  computed: {
    ...mapGetters(['getCurrentBookshelf'])
  },
  async beforeMount() {
    this.num = await this.$store.dispatch(BOOKSHELF_BOOK_COUNT, {
      bookshelfId: this.bookshelf.id || ''
    })
  },
  async mounted() {
    // console.log(this.getCurrentBookshelf?.id)
  },
  methods: {
    navigateBookshelf() {
      const id = this.bookshelf.id
      if (!this.getCurrentBookshelf) {
        this.$store.commit(BOOKSHELF_SET_CURRENT, id)
        this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, { id })
      }
      if (this.getCurrentBookshelf.id !== id) {
        this.$store.commit(BOOKSHELF_SET_CURRENT, id)
        this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, { id })
      }

      if (id === '') {
        this.$router.push({ name: 'library_default' }).catch(() => {})
      } else {
        this.$router.push({ name: 'library', params: { id } }).catch(() => {})
      }

      this.$emit('closeMobileMenu')
    },
    toggleEditMenu() {
      this.showEditMenu = !this.showEditMenu
    },
    closeEditMenu() {
      this.showEditMenu = false
    }
  }
}
</script>

<style lang="scss" scoped>
.snb_sub {
  li {
    &.active {
      .num_style {
        color: #ffffff;
      }
    }
  }
}
.snb_list {
  text-align: left;
}

.snb_list span b {
  font-size: 5px;
  vertical-align: top;
  margin-right: 8px;
}
.num_style {
  color: #595959;
}
</style>
